<template>
  <div v-if="project" class="d-flex hover-container py-2">
    <requirement-user-avatar
      :large="true"
      :fullname="teamMember.user ? (teamMember.user.firstname + ' ' + teamMember.user.lastname) : null"
    ></requirement-user-avatar>

    <div class="pt-1 ml-2">
      <p v-if="teamMember.user" class="ma-0" :class="{'font-weight-bold': isProjectOwner(teamMember, project)}">
        {{ teamMember.user.firstname }} {{ teamMember.user.lastname }}
        <v-tooltip v-if="isProjectOwner(teamMember, project)" location="bottom">
          <template v-slot:activator="{ props: props }">
            <span v-bind="props"> (Owner)</span>
          </template>
          <span>The owner of this project.</span>
        </v-tooltip>
        <v-tooltip v-if="isLoggedInUser(teamMember)" location="bottom">
          <template v-slot:activator="{ props: props }">
            <span class="font-weight-bold" v-bind="props"> (You)</span>
          </template>
          <span>This logged in user.</span>
        </v-tooltip>
      </p>
      <p v-else class="ma-0">
        {{ teamMember.email }}
      </p>
    </div>

    <v-spacer/>
    <div v-if="!$store.state.isWorkflowDisabled" class="show-on-hover">
      <v-menu>
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            icon="mds:more_horiz"
            variant="plain"
          />
        </template>
        <v-list>
          <v-list-item
            :disabled="isProjectOwner(teamMember, project)"
            @click="deleteTeamMember($router, teamMember, project.id)">
            <v-list-item-title>Remove <span v-if="isProjectOwner(teamMember, project)">(cannot remove owner)</span></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import isToday from 'date-fns/isToday'
import isYesterday from 'date-fns/isYesterday'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import projectApi from '@/api/projectApi'
import RequirementUserAvatar from '@/components/RequirementUserAvatar.vue'
import { mapState } from 'vuex'

export default {
  components: {
    RequirementUserAvatar
  },
  props: {
    teamMember: Object,
    project: Object
  },

  data () {
    return {
    }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.user
    })
  },

  methods: {
    isToday,
    isYesterday,
    formatDistanceToNow,
    deleteTeamMember: projectApi.deleteTeamMember,
    isProjectOwner: (teamMember, project) => teamMember.userId === project.organisation.userId,
    isLoggedInUser (teamMember) {
      return teamMember.userId === this.currentUser?.id
    }
  }
}
</script>

<style scoped>
.online-status {
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
}

.online-status.online {
  background: #c6f4b0;
}

.online-status.recent {
  background: #ffea86;
}

.online-status.offline {
  background: #f16e81;
}
</style>
